import WelcomePage from '../screens/WelcomePage/';
import SearchClient from '../screens/ClientInformation/screens/SearchClient';
import AddClient from '../screens/ClientInformation/screens/AddClient';
import EditClient from '../screens/ClientInformation/screens/EditClient';
import ViewClient from '../screens/ClientInformation/screens/ViewClient';
import ClientDetails from '../screens/ClientDetails/screens';
import FilingDetails from '../components/FilingDetails';
import PendingFilings from '../screens/PendingFilings';
import PendingSecurities from '../screens/PendingSecurities';
import EditPendingTrust from '../screens/PendingSecurities/EditPendingTrust';
import EditPendingPortfolio from '../screens/PendingSecurities/EditPendingPortfolio';
import EditPendingClass from '../screens/PendingSecurities/EditPendingClass';
import NewRequest from '../screens/NewRequest/screens';
import Filings from '../screens/SearchFilings/';
import SignUp from '../screens/SignUp/screens';
import EditUser from '../screens/SignUp/screens/EditUser';
import ViewUser from '../screens/SignUp/screens/ViewUser';
import ManageStates from '../screens/ManageStates/screens';
import EditState from '../screens/ManageStates/screens/EditState';
import NewFilingRequest from '../screens/NewFilingRequest';
import QuickFilingRequest from '../screens/QuickFilingRequest';

export const routes = [
    {
        path: '/',
        component: WelcomePage,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/client-information',
        component: SearchClient,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/add-client',
        component: AddClient,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/edit-client',
        component: EditClient,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/view-client',
        component: ViewClient,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/manage-states',
        component: ManageStates,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/edit-state',
        component: EditState,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/client-details',
        component: ClientDetails,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/pending-filings',
        component: PendingFilings,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/filing-details',
        component: FilingDetails,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/pending-securities',
        component: PendingSecurities,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/edit-pending-trust',
        component: EditPendingTrust,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/edit-pending-portfolio',
        component: EditPendingPortfolio,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/edit-pending-class',
        component: EditPendingClass,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/new-request',
        component: NewRequest,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/filings',
        component: Filings,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/sign-up',
        component: SignUp,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/edit-user',
        component: EditUser,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/view-user',
        component: ViewUser,
        exact: true,
        roles: ['Administrator']
    },
    {
        path: '/new-filing-request',
        component: NewFilingRequest,
        exact: true,
        roles: ['Administrator', 'User']
    },
    {
        path: '/quick-filing-request',
        component: QuickFilingRequest,
        exact: true,
        roles: ['Administrator', 'User']
    }
];



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/services/employeePanel.routes.js